import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { environment } from '../../environments/environment';

export interface AppState {
  router: RouterReducerState;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];

export function logger(reducer: any) {
  return function(state: any, action: any) {
    const result = reducer(state, action);
    console.groupCollapsed(action.type);
    console.log('prev state', state);
    console.log('action', action);
    console.log('next state', result);
    console.groupEnd();
    return result;
  };
}

export { StateModule } from './state.module';
export { AuthStateModule } from './auth/auth-state.module';

export { AuthFacade } from './auth/auth.facade';
export { CareFacade } from './care/care.facade';
export { SafetyAnalyticsFacade } from './safety-analytics/safety-analytics.facade';
export { RemindersAnalyticsFacade } from './reminders-analytics/reminders-analytics.facade';
export { CommunicationAnalyticsFacade } from './communication-analytics/communication-analytics.facade';
export { MatchingAnalyticsFacade } from './matching-analytics/matching-analytics.facade';
